import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextBreak } from 'flow-builder/node/textBreak';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import HideStrategyModal from '../../../containers/modals/hidestrategy';
import { HideStrategy } from '../../types';
export const HIDE_STRATEGY_NAMES = {
    [HideStrategy.ALL_AGENTS_AWAY]: 'Hide when all agents are either away or offline',
    [HideStrategy.ALL_AGENTS_OFFLINE]: 'Hide when all agents are offline',
    [HideStrategy.NEVER]: 'Never hide',
    [HideStrategy.EXPECTED_WAITING_TIME]: 'Hide when expected waiting time is above threshold',
};
const translatePayload = ({ payload, }) => {
    const ports = payload.strategy !== HideStrategy.NEVER
        ? [
            {
                id: uuid(),
                label: 'Hidden',
                connection: payload.hiddenNodeId || uuid(),
            },
        ]
        : [];
    return [
        ...ports,
        {
            id: uuid(),
            label: 'Shown',
            connection: payload.shownNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const { payload } = node;
    const fieldToUpdate = connection.connectionLabel === 'Shown' ? 'shownNodeId' : 'hiddenNodeId';
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { [fieldToUpdate]: connectionId }) });
};
export const HideStrategyNodeAttributes = {
    iconName: 'hide-strategy',
    label: 'Hide strategy',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: HideStrategyNode,
    ActionModal: HideStrategyModal,
};
export function HideStrategyNode({ node }) {
    const { payload } = node;
    const { strategy } = payload;
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextBreak, { children: [_jsx(Text, { weight: "normal", text: "Strategy:" }), _jsx(Text, { weight: "semibold", text: HIDE_STRATEGY_NAMES[strategy] })] })), [strategy]) }));
}
